// extracted by mini-css-extract-plugin
export var continer = "search-bar-module--continer--28uQR";
export var gscCompletionContainer = "search-bar-module--gsc-completion-container--60jlO";